module.exports = __webpack_public_path__ + "img/speak.72b40951.png";